/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { Component } from 'react';
import {
    Route, Routes,
} from 'react-router-dom';
import SourcesContainer from './SourcesContainer';
import CreateSourceContainer from "./CreateSourceContainer";
import EditSourceContainer from './EditSourceContainer';

export default class SourcesRouter extends Component {
    static propTypes = {

    };

    static defaultProps = {

    };

    render() { // eslint-disable-line
        return (
            <Routes>
                <Route path="/" element={<SourcesContainer/>} />
                <Route path="/create-source" element={<CreateSourceContainer/>} />
                <Route path="/:id/edit-source" element={<EditSourceContainer/>} />
            </Routes>
        );
    }
}
